export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/orbit-03.03cf5577-a8ce6a.svg";